import gql from 'graphql-tag';

export const DocumentsQuery = gql`
  query documentList($ids: [String!]!) {
    documentList(ids: $ids) {
      id
      name
      latestDealScore {
        score
        timestamp
      }
    }
  }
`;
